import { library, dom } from '@fortawesome/fontawesome-svg-core';
// brands
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
// solid
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome';
import { faThLarge } from '@fortawesome/free-solid-svg-icons/faThLarge';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons/faSlidersH';
import { faCamera } from '@fortawesome/free-solid-svg-icons/faCamera';
import { faCube } from '@fortawesome/free-solid-svg-icons/faCube';
import { faCog } from '@fortawesome/free-solid-svg-icons/faCog';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons/faCircleNotch';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown';

// regular
import { faEye } from '@fortawesome/free-regular-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons/faEyeSlash';
import { faMap } from '@fortawesome/free-regular-svg-icons/faMap';
import { faClone } from '@fortawesome/free-regular-svg-icons/faClone';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons/faFilePdf';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons/faTrashAlt';
import { faPlayCircle } from '@fortawesome/free-regular-svg-icons/faPlayCircle';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons/faTimesCircle';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons/faCheckCircle';

// Add only used icons
library.add(faFacebookF);
library.add(faTwitter);
library.add(faLinkedinIn);
library.add(faFacebook);
library.add(faLinkedin);
library.add(faExclamationCircle);
library.add(faSearch);
library.add(faEye);
library.add(faEyeSlash);
library.add(faHome);
library.add(faThLarge);
library.add(faSlidersH);
library.add(faCamera);
library.add(faCube);
library.add(faCog);
library.add(faMap);
library.add(faClone);
library.add(faFilePdf);
library.add(faTrashAlt);
library.add(faPlayCircle);
library.add(faCircleNotch);
library.add(faTimesCircle);
library.add(faAngleRight);
library.add(faAngleUp);
library.add(faAngleDown);
library.add(faCheckCircle);

// Replace any existing <i> tags with <svg> and set up a MutationObserver to
// continue doing this as the DOM changes.
dom.watch();
